import { TRule } from '../../typings';

export const MOTOBOX_STOCKLIST_RULESET: TRule[] = [
  {
    type: 'rule.operate',
    sourceKey: "c.['Manufacturer_Code']",
    destination: 'product',
    targetKey: 'ean',
    operationName: 'getMotoboxEAN',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Manufacturer_Code']",
    destination: 'product',
    targetKey: 'manufacturerCode',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Quantity']",
    destination: 'product',
    targetKey: 'qty',
    outputType: 'number',
  },
  {
    type: 'rule.template',
    destination: 'product',
    targetKey: 'packageQuantity',
    template: '1',
    outputType: 'number',
  },
];
